<div class="p-3 bg-green color-white">
	<p class="small uc text-center mb-0">Ajouter une mare</p>
</div>

<div id="map"></div>
<div id="form"></div>
